<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">CONTENTS</p>
<p class="toc"><a href="#/intro">Introduction</a></p>
<p class="toc1"><a href="#/chapter01">1. The Richmond Victorian Inn</a></p>
<p class="toc"><span href="#/chapter02" title="Link target outside of Sample">2. Ye Olde England Inne</span></p>
<p class="toc"><span href="#/chapter03" title="Link target outside of Sample">3. The Old Stagecoach Inn</span></p>
<p class="toc"><span href="#/chapter04" title="Link target outside of Sample">4. The Norwich Inn</span></p>
<p class="toc"><span href="#/chapter05" title="Link target outside of Sample">5. The Readmore Inn</span></p>
<p class="toc"><span href="#/chapter06" title="Link target outside of Sample">6. Highgate Manor</span></p>
<p class="toc"><span href="#/chapter07" title="Link target outside of Sample">7. The Equinox Hotel</span></p>
<p class="toc"><span href="#/chapter08" title="Link target outside of Sample">8. The White House Inn</span></p>
<p class="toc"><span href="#/chapter09" title="Link target outside of Sample">9. The Quechee Inn</span></p>
<p class="toc"><span href="#/chapter10" title="Link target outside of Sample">10. The Spirit Capital of the Universe</span></p>
<p class="toc"><span href="#/chapter11" title="Link target outside of Sample">11. Green Mountain Inn</span></p>
<p class="toc"><span href="#/chapter12" title="Link target outside of Sample">12. The Question of Emily’s Bridge</span></p>
<p class="toc"><span href="#/chapter13" title="Link target outside of Sample">13. The Brass Lantern Inn</span></p>
<p class="toc"><span href="#/chapter14" title="Link target outside of Sample">14. Hair-Raising Day Trips</span></p>
<p class="toc"><span href="#/chapter15" title="Link target outside of Sample">15. The Ghost Town of Glastenbury</span></p>
<p class="toc"><span href="#/chapter16" title="Link target outside of Sample">16. I’ll Have What She’s Having</span></p>
<p class="toc"><span href="#/chapter17" title="Link target outside of Sample">17. A Ghost to Call Your Own</span></p>
<p class="toc1"><span href="#/bib" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?7023d78f